<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-form-item
          :label="$l('shipment_customer_shipmentType') || '收发货人'"
        >
          <el-radio-group v-model="formData.shipmentType">
            <el-radio label="S">
              {{ $l('shipment_customer_shipmentType_S') || '发货人' }}
            </el-radio>
            <el-radio label="C">
              {{ $l('shipment_customer_shipmentType_C') || '收货人' }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('shipment_customer_numberType') || '发运客户代码类型'"
          >
            <el-input
              v-model="formData.numberType"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('shipment_customer_shipmentCustomerNo') || '发运客户代码'
            "
          >
            <el-input
              v-model="formData.shipmentCustomerNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('shipment_customer_shipmentCustomerName') || '发运客户名称'
            "
            prop="shipmentCustomerName"
          >
            <el-input
              v-model="formData.shipmentCustomerName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('shipment_customer_shipmentCustomerEnName') ||
                '发运客户英文名称'
            "
          >
            <el-input
              v-model="formData.shipmentCustomerEnName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="80"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('shipment_customer_shipmentCustomerPhoneNo') || '发运客户电话'
            "
          >
            <el-input
              clearable
              v-model="formData.shipmentCustomerPhoneNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('shipment_customer_regionNo') || '国家代码'"
            prop="regionNo"
          >
            <el-input
              clearable
              v-model="formData.regionNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('shipment_customer_aeoNo') || 'AEO企业代码'">
            <el-input
              clearable
              v-model="formData.aeoNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="
              $l('shipment_customer_shipmentCustomerAddress') || '发运客户地址'
            "
            prop="shipmentCustomerAddress"
          >
            <el-input
              v-model="formData.shipmentCustomerAddress"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('shipment_customer_custCode') || '所属客户'">
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              clearable
              filterable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('shipment_customer_contacts') || '联系人'">
            <el-input
              v-model="formData.contacts"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('shipment_customer_contactsPhoneNo') || '联系电话'"
          >
            <el-input
              v-model="formData.contactsPhoneNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('shipment_customer_contactsEmail') || '联系邮件地址'"
          >
            <el-input
              v-model="formData.contactsEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('shipment_customer_contactsFax') || '联系传真'"
          >
            <el-input
              v-model="formData.contactsFax"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="side-frame-success">
        <span class="side-frame-text">
          {{ $l('shipment_customer_bank_info') || '开户银行信息' }}
        </span>
      </div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('shipment_customer_bankName') || '开户银行名称'"
          >
            <el-input
              clearable
              v-model="formData.bankName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('shipment_customer_bankEnName') || '开户银行英文名称'"
          >
            <el-input
              clearable
              v-model="formData.bankEnName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('shipment_customer_bankCode') || '开户银行代码'"
          >
            <el-input
              clearable
              v-model="formData.bankCode"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('shipment_customer_bankAccountName') || '开户银行账号名称'
            "
          >
            <el-input
              clearable
              v-model="formData.bankAccountName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('shipment_customer_bankAccountNo') || '开户银行账号'"
          >
            <el-input
              clearable
              v-model="formData.bankAccountNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('shipment_customer_bankAddress') || '开户银行中文地址'"
          >
            <el-input
              clearable
              v-model="formData.bankAddress"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('shipment_customer_bankEnAddress') || '开户银行英文地址'"
          >
            <el-input
              clearable
              v-model="formData.bankEnAddress"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { shipmentType: 'S' },
      rules: {
        numberType: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        shipmentCustomerNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        shipmentCustomerName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        shipmentCustomerAddress: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        shipmentCustomerPhoneNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        regionNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.shipmentCustomerCode) return

      this.$api
        .shipmentCustomerDetailApi({
          shipmentCustomerCode: this.shipmentCustomerCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      const res = await this.$api
        .shipmentCustomerSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.shipmentCustomerCode) {
        this.closeCurPage()
      } else {
        this.getData()
      }
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
